import { V3Models } from "@istari/istari-client";

import { Token } from "~/resource/model/token";

export function toToken(token: V3Models.TokenDto): Token {
  return {
    sha: token.sha,
    salt: token.salt,
  };
}
